
let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    $('.product-form__payment-container').before($('#avpoptions-container__v2'));
    clearInterval(interval);
  }
}, 100);

function forceQuitInterval(){
  clearInterval(interval);
}

setTimeout(forceQuitInterval, 10000);


// Start: Plus add charge into price of product
let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

let originPriceText = null;
let originPrice = null;
let originPriceTextSale = null;
let originPriceSale = null;
let interval3 = setInterval(function () {
  let ap_elements = document.querySelector('#avpoptions-container__v2');
  if (ap_elements) {
    if (!originPriceText && $('.product-form__info-list .price').length) {
      originPriceText = $('.product-form__info-list .price')[0].innerHTML;
      originPrice = parseFloat($('.product-form__info-list .price')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
    }

    if (!originPriceTextSale && $('.product-form__info-list .price.price--highlight').length) {
      originPriceTextSale = $('.product-form__info-list .price.price--highlight')[0].innerHTML;
      originPriceSale = parseFloat($('.product-form__info-list .price.price--highlight')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
    }
    if (originPriceText && originPrice && $('#avp-productoption-total-add').is(':visible')){
      let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
      let newPrice = originPrice + addChargePrice;
      let newPriceSale = originPriceSale + addChargePrice;
      $('.product-form__info-list .price')[0].innerHTML = formatter.format(newPrice);
      if ($('.product-form__info-list .price.price--highlight').length) {
        $('.product-form__info-list .price.price--highlight')[0].innerHTML = formatter.format(newPriceSale);
      }

    } else {
      $('.product-form__info-list .price')[0].innerHTML = originPriceText;
      if ($('.product-form__info-list .price.price--highlight').length) {
        $('.product-form__info-list .price.price--highlight')[0].innerHTML = originPriceTextSale;
      }
    }
  } 
}, 100);
// End: Plus add charge into price of product